import reducer from './events';
import { actionCreators, EventsActionType } from './events.actionCreators';
import * as actionTypes from './events.actionTypes';

export * from './events'; // expose all types
export * from './events.selectors';
export type ActionType = EventsActionType;
export { actionTypes, actionCreators };
export default reducer;
